const updateStoreConstant = {
  UPDATE_COMPANY_STATUS: "UPDATE_COMPANY_STATUS",
}

export default updateStoreConstant;